module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "toc"
    }
  }, [_c('p', {
    staticClass: "ctfm"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0006#tab",
      "id": "rtab"
    }
  }, [_c('em', [_vm._v("Tables")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0007#pre",
      "id": "rpre"
    }
  }, [_c('em', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0008#abb",
      "id": "rabb"
    }
  }, [_c('em', [_vm._v("Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0009#ch01",
      "id": "rch01"
    }
  }, [_vm._v("1. From the Historical Jesus to the Jesus of Testimony")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0010#ch02",
      "id": "rch02"
    }
  }, [_vm._v("2. Papias on the Eyewitnesses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0011#ch03",
      "id": "rch03"
    }
  }, [_vm._v("3. Names in the Gospel Traditions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0012#ch04",
      "id": "rch04"
    }
  }, [_vm._v("4. Palestinian Jewish Names")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0013#ch05",
      "id": "rch05"
    }
  }, [_vm._v("5. The Twelve")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0014#ch06",
      "id": "rch06"
    }
  }, [_vm._v("6. Eyewitnesses “from the Beginning”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0015#ch07",
      "id": "rch07"
    }
  }, [_vm._v("7. The Petrine Perspective in the Gospel of Mark")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0016#ch08",
      "id": "rch08"
    }
  }, [_vm._v("8. Anonymous Persons in Mark’s Passion Narrative")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0017#ch09",
      "id": "rch09"
    }
  }, [_vm._v("9. Papias on Mark and Matthew")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0018#ch10",
      "id": "rch10"
    }
  }, [_vm._v("10. Models of Oral Tradition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0019#ch11",
      "id": "rch11"
    }
  }, [_vm._v("11. Transmitting the Jesus Traditions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0020#ch12",
      "id": "rch12"
    }
  }, [_vm._v("12. Anonymous Tradition or Eyewitness Testimony?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0021#ch13",
      "id": "rch13"
    }
  }, [_vm._v("13. Eyewitness Memory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0022#ch14",
      "id": "rch14"
    }
  }, [_vm._v("14. The Gospel of John as Eyewitness Testimony")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0023#ch15",
      "id": "rch15"
    }
  }, [_vm._v("15. The Witness of the Beloved Disciple")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0024#ch16",
      "id": "rch16"
    }
  }, [_vm._v("16. Papias on John")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0025#ch17",
      "id": "rch17"
    }
  }, [_vm._v("17. Polycrates and Irenaeus on John")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0026#ch18",
      "id": "rch18"
    }
  }, [_vm._v("18. The Jesus of Testimony")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0027#ind01",
      "id": "rind01"
    }
  }, [_c('em', [_vm._v("Index of Ancient Persons")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0028#ind02",
      "id": "rind02"
    }
  }, [_c('em', [_vm._v("Index of Modern Authors")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0029#ind03",
      "id": "rind03"
    }
  }, [_c('em', [_vm._v("Index of Places")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0030#ind04",
      "id": "rind04"
    }
  }, [_c('em', [_vm._v("Index of Scriptures and Other Ancient Writings")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31cd72df","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eer-bauckham-0005.vue
// module id = 66
// module chunks = 0